module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-1-7dd4146ad6f9333a7741f4536f98e3c2.webp";